/* eslint-disable unicorn/prefer-node-protocol */
import fs from 'fs'
import path from 'path'

import type { Messages } from '@lingui/core'
import type { EHostKey } from '@loc/hosts/src/constants'

const getProjectRootPath = () => {
  const projectRoot = process.cwd()
  return projectRoot
}

export async function loadTranslation(
  locale = 'en',
  deepHostKey: EHostKey,
  pagePathName: string,
) {
  if (typeof window !== 'undefined') {
    return {}
  }

  const pathsToLoad = []
  const allMessages: Messages = {}
  const projectRoot = getProjectRootPath()

  if (pagePathName.includes('/404') || pagePathName.includes('/500')) {
    pathsToLoad.push(`./src/locales/src/pages/_app.page/${locale}.json`)
    pathsToLoad.push(
      `./src/locales/src/pages${pagePathName}.page/${locale}.json`,
    )
    pathsToLoad.push(
      `./src/locales/src/pages/${deepHostKey}/_layout/index/${locale}.json`,
    )
  } else {
    pathsToLoad.push(`./src/locales/src/pages/_app.page/${locale}.json`)
    pathsToLoad.push(
      `./src/locales/src/pages${pagePathName}/index.page/${locale}.json`,
    )
    pathsToLoad.push(
      `./src/locales/src/pages${pagePathName}.page/${locale}.json`,
    )
    pathsToLoad.push(
      `./src/locales/src/pages/${deepHostKey}/_layout/index/${locale}.json`,
    )
  }
  const settledResults = await Promise.allSettled(
    pathsToLoad.map(async (relativePath) => {
      const absolutePath = path.join(projectRoot, relativePath)
      try {
        if (fs.existsSync(absolutePath)) {
          const fileContent = await fs.promises.readFile(absolutePath, 'utf-8')
          const jsonData = JSON.parse(fileContent)
          return { messages: jsonData.messages }
        } else {
          return { messages: {} }
        }
      } catch (error) {
        return { messages: {} }
      }
    }),
  )
  settledResults.forEach((cur) => {
    if (cur.status === 'fulfilled') {
      Object.assign(allMessages, cur.value.messages)
    }
  })
  return allMessages
}
